<template>
  <el-form :model="form" :rules="rules" ref="form">
    <el-form-item label="账号名称： ">
      <span>{{ step1Data.accountName }}</span>
    </el-form-item>
    <el-form-item prop="password">
      <el-input
        v-model.trim="form.password"
        type="password"
        @keyup.enter.native="primaryBtnClick"
        prefix-icon="el-icon-lock"
        placeholder="请输入新密码"
      ></el-input>
    </el-form-item>
    <el-form-item prop="confirmPassword">
      <el-input
        v-model.trim="form.confirmPassword"
        type="password"
        @keyup.enter.native="primaryBtnClick"
        prefix-icon="el-icon-lock"
        placeholder="请确认新密码"
      ></el-input>
    </el-form-item>
    <el-form-item class="mt-24">
      <PrimaryBtn :loading="loading" @click="primaryBtnClick"> 保存新密码 </PrimaryBtn>
    </el-form-item>
  </el-form>
</template>

<script>
import PrimaryBtn from '../../components/LoginPrimaryBtn';
import { forgetPasswordStep3 } from '@/api/login-api';
import { validPassword } from '../validate.js';
export default {
  name: 'StepSecond',
  components: {
    PrimaryBtn,
  },
  props: {
    step1Data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const _this = this;
    return {
      form: {
        password: '',
        confirmPassword: '',
      },
      rules: {
        password: [{ required: true, validator: validPassword, trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: _this.validateConfirmPassword, trigger: 'blur' },
        ],
      },
      loading: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    validateConfirmPassword(rule, value, callback) {
      const { password } = this.form;
      console.log('validateConfirmPassword', password, value);
      if (password !== value) {
        return callback(new Error('密码输入不一致，请重新输入'));
      }
      callback();
    },
    primaryBtnClick() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        this.loading = true;
        const { accountId, staffId } = this.step1Data;
        const { password, confirmPassword } = this.form;
        forgetPasswordStep3({
          accountId,
          staffId,
          password,
          rePassword: confirmPassword,
        })
          .then(res => {
            const { data, result } = res;
            this.loading = false;
            if (result !== 1) {
              return false;
            }
            this.$emit('on-success');
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>
